/* eslint-disable no-underscore-dangle */
import React from 'react'

export type SectorOutlookCellProps = {
  cellProps: any
  isPrintPreview?: boolean
  handleClick: () => void
}

export const sectorOutlookFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { sectorOutlook } = data._original
  return sectorOutlook && sectorOutlook.toLowerCase().includes(filter)
}

export const SectorOutlookCell = (props: SectorOutlookCellProps) => {
  const { cellProps, handleClick, isPrintPreview = false } = props
  const { sectorOutlookCode = '', sectorOutlook = '' } = cellProps.original
  const iconClick = () => {
    handleClick()
  }
  return (
    <>
      {sectorOutlookCode ? (
        <div className="ratings-key">
          {isPrintPreview ? (
            `${sectorOutlook}`
          ) : (
            <span
              role="button"
              className={sectorOutlookCode}
              onClick={iconClick}
              onKeyDown={iconClick}
              tabIndex={0}
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>
      ) : null}
    </>
  )
}
export default SectorOutlookCell
